import React from 'react';

export default function NotFoundPage() {
  return (
    <div
      style={{
        background: '#0a0f1a',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <p
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(64px, 10vw, 120px)',
            lineHeight: 0.9,
            color: '#e10600',
            margin: 0,
          }}
        >
          404
        </p>
        <h1
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(28px, 4vw, 40px)',
            color: '#ffffff',
            margin: '16px 0 12px',
            letterSpacing: -0.5,
          }}
        >
          Page not found
        </h1>
        <p
          style={{
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 15,
            color: 'rgba(255,255,255,0.55)',
            margin: '0 0 28px',
          }}
        >
          The page you are looking for does not exist.
        </p>
        <a
          href="/"
          style={{
            display: 'inline-block',
            background: '#e10600',
            color: '#ffffff',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontWeight: 700,
            fontSize: 14,
            padding: '14px 32px',
            borderRadius: 8,
            textDecoration: 'none',
            letterSpacing: 0.3,
          }}
        >
          Back to home
        </a>
      </div>
    </div>
  );
}
